module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="cw-fieldset c-form__scrollZone">\r\n  <div class="form-group">\r\n    <label for="compteur.code" class="cw-required">'+
((__t=(i18n.t('common:parametragebresultats.table_col_compteur')))==null?'':__t)+
'</label>\r\n    <span class="cmbCompteur" data-column="compteur.code"></span>\r\n  </div>\r\n  <div class="form-group">\r\n    <label for="typeresultat.code" class="cw-required">'+
((__t=(i18n.t('common:parametragebresultats.table_col_type')))==null?'':__t)+
'</label>\r\n    <span class="cmbTypeRes" data-column="typeresultat.code"></span>\r\n  </div>\r\n  <div class="periodicite form-group">\r\n    <label for="periodicite.code" class="cw-required">'+
((__t=(i18n.t('common:parametragebresultats.table_col_periodicite')))==null?'':__t)+
'</label>\r\n    <span class="cmbPeriodicite" data-column="periodicite.code"></span>\r\n  </div>\r\n  <div class="periodevalo form-group">\r\n    <label for="periodevalo.code" class="cw-required">'+
((__t=(i18n.t('common:parametragebresultats.table_col_periode')))==null?'':__t)+
'</label>\r\n    <span class="cmbPeriodeValo" data-column="periodevalo.code"></span>\r\n  </div>  \r\n</fieldset>';
}
return __p;
};
